import React from 'react'

// Import Global Styles
import './src/styles/styles.css'
// Google Fonts now loaded async via gatsby-ssr.js (no render-blocking)
// Import Nav Styles
import './src/styles/nav.css'
// Import Blog Body Styles
import './src/styles/blog-body.css'
// Import Simplebar React Styles
import 'simplebar-react/dist/simplebar.min.css'
// Page Progress Bar removed - component is disabled in Layout.js

// Import Provider
import Provider from './src/provider'

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>
